import { render, staticRenderFns } from "./AttributeFilterPanel.vue?vue&type=template&id=f80b132c"
import script from "./AttributeFilterPanel.vue?vue&type=script&lang=js"
export * from "./AttributeFilterPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports